export default __webpack_public_path__ + "e456c7b0be0cf1ccfb6dcc3f68629898.jpg";